import {
  commonValidationSchemas,
  createValidationSchema,
} from 'infrastructure/functions';
import i18next from 'i18next';

export const patientThresholdsValidationSchema = () =>
  createValidationSchema({
    minCriticalSystolic: commonValidationSchemas.number({
      required: true,
      isInteger: true,
      min: 0,
      max: 200,
      lessThanMultiple: [
        {
          field: 'maxCriticalSystolic',
          fieldName: i18next.t('labels.maxCritical'),
        },
        {
          field: 'minRiskSystolic',
          fieldName: i18next.t('labels.minAtRisk'),
        },
        {
          field: 'maxRiskSystolic',
          fieldName: i18next.t('labels.maxAtRisk'),
        },
      ],
    }),
    maxCriticalSystolic: commonValidationSchemas.number({
      required: true,
      isInteger: true,
      min: 0,
      max: 200,
      moreThanMultiple: [
        {
          field: 'minCriticalSystolic',
          fieldName: i18next.t('labels.minCritical'),
        },
        {
          field: 'minRiskSystolic',
          fieldName: i18next.t('labels.minAtRisk'),
        },
        {
          field: 'maxRiskSystolic',
          fieldName: i18next.t('labels.maxAtRisk'),
        },
      ],
    }),
    minRiskSystolic: commonValidationSchemas.number({
      required: true,
      isInteger: true,
      min: 0,
      max: 200,
      moreThan: {
        field: 'minCriticalSystolic',
        fieldName: i18next.t('labels.minCritical'),
      },
      lessThanMultiple: [
        {
          field: 'maxRiskSystolic',
          fieldName: i18next.t('labels.maxAtRisk'),
        },
        {
          field: 'maxCriticalSystolic',
          fieldName: i18next.t('labels.maxCritical'),
        },
      ],
    }),
    maxRiskSystolic: commonValidationSchemas.number({
      required: true,
      isInteger: true,
      min: 0,
      max: 200,
      moreThanMultiple: [
        {
          field: 'minRiskSystolic',
          fieldName: i18next.t('labels.minAtRisk'),
        },
        {
          field: 'minCriticalSystolic',
          fieldName: i18next.t('labels.minCritical'),
        },
      ],
      lessThan: {
        field: 'maxCriticalSystolic',
        fieldName: i18next.t('labels.maxCritical'),
      },
    }),
    minCriticalDiastolic: commonValidationSchemas.number({
      required: true,
      isInteger: true,
      min: 0,
      max: 200,
      lessThanMultiple: [
        {
          field: 'maxCriticalDiastolic',
          fieldName: i18next.t('labels.maxCritical'),
        },
        {
          field: 'minRiskDiastolic',
          fieldName: i18next.t('labels.minAtRisk'),
        },
        {
          field: 'maxRiskDiastolic',
          fieldName: i18next.t('labels.maxAtRisk'),
        },
      ],
    }),
    maxCriticalDiastolic: commonValidationSchemas.number({
      required: true,
      isInteger: true,
      min: 0,
      max: 200,
      moreThanMultiple: [
        {
          field: 'minCriticalDiastolic',
          fieldName: i18next.t('labels.minCritical'),
        },
        {
          field: 'minRiskDiastolic',
          fieldName: i18next.t('labels.minAtRisk'),
        },
        {
          field: 'maxRiskDiastolic',
          fieldName: i18next.t('labels.maxAtRisk'),
        },
      ],
    }),
    minRiskDiastolic: commonValidationSchemas.number({
      required: true,
      isInteger: true,
      min: 0,
      max: 200,
      moreThan: {
        field: 'minCriticalDiastolic',
        fieldName: i18next.t('labels.minCritical'),
      },
      lessThanMultiple: [
        {
          field: 'maxRiskDiastolic',
          fieldName: i18next.t('labels.maxAtRisk'),
        },
        {
          field: 'maxCriticalDiastolic',
          fieldName: i18next.t('labels.maxCritical'),
        },
      ],
    }),
    maxRiskDiastolic: commonValidationSchemas.number({
      required: true,
      isInteger: true,
      min: 0,
      max: 200,
      moreThanMultiple: [
        {
          field: 'minRiskDiastolic',
          fieldName: i18next.t('labels.minAtRisk'),
        },
        {
          field: 'minCriticalDiastolic',
          fieldName: i18next.t('labels.minCritical'),
        },
      ],
      lessThan: {
        field: 'maxCriticalDiastolic',
        fieldName: i18next.t('labels.maxCritical'),
      },
    }),
    minCriticalPulse: commonValidationSchemas.number({
      required: true,
      isInteger: true,
      min: 0,
      max: 200,
      lessThanMultiple: [
        {
          field: 'minRiskPulse',
          fieldName: i18next.t('labels.minAtRisk'),
        },
        {
          field: 'maxRiskPulse',
          fieldName: i18next.t('labels.maxAtRisk'),
        },
        {
          field: 'maxCriticalPulse',
          fieldName: i18next.t('labels.maxCritical'),
        },
      ],
    }),
    maxCriticalPulse: commonValidationSchemas.number({
      required: true,
      isInteger: true,
      min: 0,
      max: 200,
      moreThanMultiple: [
        {
          field: 'maxRiskPulse',
          fieldName: i18next.t('labels.maxAtRisk'),
        },
        {
          field: 'minRiskPulse',
          fieldName: i18next.t('labels.minAtRisk'),
        },
        {
          field: 'minCriticalPulse',
          fieldName: i18next.t('labels.minCritical'),
        },
      ],
    }),
    minCriticalSleepPulse: commonValidationSchemas.number({
      required: true,
      isInteger: true,
      min: 0,
      max: 200,
      lessThanMultiple: [
        {
          field: 'minRiskSleepPulse',
          fieldName: i18next.t('labels.minAtRisk'),
        },
        {
          field: 'maxRiskSleepPulse',
          fieldName: i18next.t('labels.maxAtRisk'),
        },
        {
          field: 'maxCriticalSleepPulse',
          fieldName: i18next.t('labels.maxCritical'),
        },
      ],
    }),
    maxCriticalSleepPulse: commonValidationSchemas.number({
      required: true,
      isInteger: true,
      min: 0,
      max: 200,
      moreThanMultiple: [
        {
          field: 'minCriticalSleepPulse',
          fieldName: i18next.t('labels.minCritical'),
        },
        {
          field: 'minRiskSleepPulse',
          fieldName: i18next.t('labels.minAtRisk'),
        },
        {
          field: 'maxRiskSleepPulse',
          fieldName: i18next.t('labels.maxAtRisk'),
        },
      ],
    }),
    minRiskPulse: commonValidationSchemas.number({
      required: true,
      isInteger: true,
      min: 0,
      max: 200,
      moreThan: {
        field: 'minCriticalPulse',
        fieldName: i18next.t('labels.minCritical'),
      },
      lessThanMultiple: [
        {
          field: 'maxRiskPulse',
          fieldName: i18next.t('labels.maxAtRisk'),
        },
        {
          field: 'maxCriticalPulse',
          fieldName: i18next.t('labels.maxCritical'),
        },
      ],
    }),
    maxRiskPulse: commonValidationSchemas.number({
      required: true,
      isInteger: true,
      min: 0,
      max: 200,
      moreThanMultiple: [
        {
          field: 'minRiskPulse',
          fieldName: i18next.t('labels.minAtRisk'),
        },
        {
          field: 'minCriticalPulse',
          fieldName: i18next.t('labels.minCritical'),
        },
      ],
      lessThan: {
        field: 'maxCriticalPulse',
        fieldName: i18next.t('labels.maxCritical'),
      },
    }),
    minRiskSleepPulse: commonValidationSchemas.number({
      required: true,
      isInteger: true,
      min: 0,
      max: 200,
      moreThan: {
        field: 'minCriticalSleepPulse',
        fieldName: i18next.t('labels.minCritical'),
      },
      lessThanMultiple: [
        {
          field: 'maxRiskSleepPulse',
          fieldName: i18next.t('labels.maxAtRisk'),
        },
        {
          field: 'maxCriticalSleepPulse',
          fieldName: i18next.t('labels.maxCritical'),
        },
      ],
    }),
    maxRiskSleepPulse: commonValidationSchemas.number({
      required: true,
      isInteger: true,
      min: 0,
      max: 200,
      moreThanMultiple: [
        {
          field: 'minRiskSleepPulse',
          fieldName: i18next.t('labels.minAtRisk'),
        },
        {
          field: 'minCriticalSleepPulse',
          fieldName: i18next.t('labels.minCritical'),
        },
      ],
      lessThan: {
        field: 'maxCriticalSleepPulse',
        fieldName: i18next.t('labels.maxCritical'),
      },
    }),
    criticalBloodoxygen: commonValidationSchemas.number({
      required: true,
      isInteger: true,
      min: 0,
      max: 100,
      lessThan: {
        field: 'riskBloodoxygen',
        fieldName: i18next.t('labels.atRisk'),
      },
    }),
    riskBloodoxygen: commonValidationSchemas.number({
      required: true,
      isInteger: true,
      min: 0,
      max: 100,
      moreThan: {
        field: 'criticalBloodoxygen',
        fieldName: i18next.t('labels.critical'),
      },
    }),
    minCriticalGlucose: commonValidationSchemas.number({
      required: true,
      isInteger: true,
      min: 0,
      max: 400,
      lessThanMultiple: [
        {
          field: 'minRiskGlucose',
          fieldName: i18next.t('labels.minAtRisk'),
        },
        {
          field: 'maxRiskGlucose',
          fieldName: i18next.t('labels.maxAtRisk'),
        },
        {
          field: 'maxCriticalGlucose',
          fieldName: i18next.t('labels.maxCritical'),
        },
      ],
    }),
    maxCriticalGlucose: commonValidationSchemas.number({
      required: true,
      isInteger: true,
      min: 0,
      max: 400,
      moreThanMultiple: [
        {
          field: 'maxRiskGlucose',
          fieldName: i18next.t('labels.maxAtRisk'),
        },
        {
          field: 'minRiskGlucose',
          fieldName: i18next.t('labels.minAtRisk'),
        },
        {
          field: 'minCriticalGlucose',
          fieldName: i18next.t('labels.minCritical'),
        },
      ],
    }),
    minRiskGlucose: commonValidationSchemas.number({
      required: true,
      isInteger: true,
      min: 0,
      max: 400,
      lessThanMultiple: [
        {
          field: 'minCriticalGlucose',
          fieldName: i18next.t('labels.minCritical'),
        },
        {
          field: 'maxCriticalGlucose',
          fieldName: i18next.t('labels.maxAtRisk'),
        },
      ],
      moreThan: {
        field: 'minCriticalGlucose',
        fieldName: i18next.t('labels.minCritical'),
      },
    }),
    maxRiskGlucose: commonValidationSchemas.number({
      required: true,
      isInteger: true,
      min: 0,
      max: 400,
      moreThanMultiple: [
        {
          field: 'minCriticalGlucose',
          fieldName: i18next.t('labels.minCritical'),
        },
        {
          field: 'minRiskGlucose',
          fieldName: i18next.t('labels.minAtRisk'),
        },
      ],
      lessThan: {
        field: 'maxCriticalGlucose',
        fieldName: i18next.t('labels.maxCritical'),
      },
    }),
    // critical decrease
    minCriticalWeightChange: commonValidationSchemas.number({
      required: true,
      isInteger: true,
      min: 0,
      moreThan: {
        field: 'minRiskWeightChange',
        fieldName: i18next.t('labels.minAtRiskChange'),
      },
    }),
    // critical increase
    maxCriticalWeightChange: commonValidationSchemas.number({
      required: true,
      isInteger: true,
      min: 0,
      moreThan: {
        field: 'maxRiskWeightChange',
        fieldName: i18next.t('labels.maxAtRiskChange'),
      },
    }),
    // at risk decrease
    minRiskWeightChange: commonValidationSchemas.number({
      required: true,
      isInteger: true,
      min: 0,
      max: 400,
      lessThan: {
        field: 'minCriticalWeightChange',
        fieldName: i18next.t('labels.minCriticalChange'),
      },
    }),
    // at risk increase
    maxRiskWeightChange: commonValidationSchemas.number({
      required: true,
      isInteger: true,
      min: 0,
      lessThan: {
        field: 'maxCriticalWeightChange',
        fieldName: i18next.t('labels.maxCriticalChange'),
      },
    }),

    minRiskPef: commonValidationSchemas.number({
      min: 0,
      moreThan: {
        field: 'minCriticalPef',
        fieldName: i18next.t('labels.minCritical'),
      },
    }),
    minCriticalPef: commonValidationSchemas.number({
      min: 0,
      lessThan: {
        field: 'minRiskPef',
        fieldName: i18next.t('labels.minAtRisk'),
      },
    }),
    minCriticalFev1: commonValidationSchemas.number({ min: 0 }),
    chfFiveDayWeightIncrease: commonValidationSchemas.number({
      min: 0,
      required: true,
      isInteger: true,
      moreThan: {
        field: 'chfDailyWeightIncrease',
        fieldName: i18next.t('labels.chfDailyIncrease'),
      },
    }),

    chfDailyWeightIncrease: commonValidationSchemas.number({
      min: 0,
      required: true,
      isInteger: true,
      lessThan: {
        field: 'chfFiveDayWeightIncrease',
        fieldName: i18next.t('labels.chfFiveDayIncrease'),
      },
    }),
    targetWeight: commonValidationSchemas.number({
      min: 0,
    }),
  });
